
import React from 'react';

const About = () => {
  return (
    <section id="about" className="py-20">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-3xl md:text-4xl font-bold text-navy mb-6 font-serif">
              About Gold Standard Cleaning Group
            </h2>
            
            <div className="w-24 h-1 bg-gold mb-6"></div>
            
            <p className="text-lg text-gray-700 mb-8 font-serif italic">
              True luxury lies in the flawless details.
            </p>
            
            <p className="text-gray-700 mb-8">
              We exist to preserve the beauty, serenity, and refinement of the spaces our 
              clients call home.
            </p>
            
            <p className="text-gray-700 mb-8">
              Our team consists of highly trained professionals, personally vetted for 
              discretion, excellence, and respect. Each member is committed to upholding 
              the highest standards of service — with quiet precision and complete 
              confidentiality.
            </p>

            <p className="text-gray-700 mb-8">
              We exclusively use premium, eco-conscious products and specialized techniques 
              designed for fine surfaces, delicate furnishings, and the unique demands of 
              luxury living environments.
            </p>
            
            <div className="bg-gray-100 p-6 border-l-4 border-gold">
              <p className="italic text-gray-700 font-serif text-lg">
                "We don't just clean homes — we maintain private sanctuaries.
                Our commitment to excellence, trust, and discretion is what sets us apart."
              </p>
              <p className="text-navy font-medium mt-3">— Founder, Gold Standard Cleaning Group</p>
            </div>
          </div>
          
          <div className="order-1 lg:order-2 relative grid grid-cols-2 gap-4">
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-24 h-24 border-t-4 border-l-4 border-gold"></div>
              <div className="rounded-lg shadow-lg w-full overflow-hidden" style={{ height: "300px" }}>
                <img 
                  src="/lovable-uploads/b340f442-a8a3-4008-a4b4-9e9f871a6bbe.png" 
                  alt="Luxury modern kitchen with white cabinets and navy blue island" 
                  className="w-full h-full object-cover object-center"
                  style={{ objectPosition: "center 30%" }}
                />
              </div>
            </div>
            <div className="relative mt-8">
              <div className="rounded-lg shadow-lg w-full overflow-hidden" style={{ height: "300px" }}>
                <img 
                  src="/lovable-uploads/2b51f06b-4cbb-438d-8994-b67d9e394fb4.png" 
                  alt="Elegant luxury marble bathroom with gold fixtures" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 w-24 h-24 border-b-4 border-r-4 border-gold"></div>
            </div>
          </div>
        </div>
        
        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center p-6">
            <div className="w-20 h-20 bg-navy/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-navy" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
            </div>
            <h3 className="text-xl font-serif font-bold text-navy mb-3">Trusted Excellence</h3>
            <p className="text-gray-600">Fully bonded and insured with a reputation built on trust and reliability.</p>
          </div>
          
          <div className="text-center p-6">
            <div className="w-20 h-20 bg-navy/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-navy" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <h3 className="text-xl font-serif font-bold text-navy mb-3">Efficient Service</h3>
            <p className="text-gray-600">Advanced techniques and equipment to deliver outstanding results in less time.</p>
          </div>
          
          <div className="text-center p-6">
            <div className="w-20 h-20 bg-navy/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-navy" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" />
              </svg>
            </div>
            <h3 className="text-xl font-serif font-bold text-navy mb-3">Eco-Friendly</h3>
            <p className="text-gray-600">Premium green cleaning solutions that protect the environment and maintain workplace health and safety standards.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
